import React from 'react';
import PropTypes from 'prop-types';

import ParameterDropdown from 'components/ParameterDropdown';
import AdditionalFields from './AdditionalFields';

const SettingsFormComponent = props => (
  <div
    id="settings-form"
    className="content-item"
  >
    <h2 className="header-page">
      Settings
    </h2>

    <ParameterDropdown
      isClearable
      id="parameter-1"
      label={props.isScatterPlotTab ? 'x-axis' : 'Variable to Graph'}
      value={props.firstDropdownValue}
      onChange={props.onFirstDropdownChange}
      isDisabled={!props.datasetLength || props.isEachDropdownDisabled}
      parameters={props.firstDropdownParameters}
    />

    {props.showSecondDropDown &&
      <ParameterDropdown
        isClearable
        isDisabled={!props.firstParameterSelected || !props.datasetLength || props.isEachDropdownDisabled}
        id="parameter-2"
        label={props.isScatterPlotTab ? 'y-axis' : 'Grouping Variable'}
        value={props.secondDropdownValue}
        onChange={props.onSecondDropdownChange}
        parameters={props.secondDropdownParameters}
      />
    }

    {(props.showHistogramFields || props.showRadioFrequency) &&
    <AdditionalFields
      key={props.secondDropdownValue || props.firstDropdownValue}
      parameter={props.numericalName}
      onFrequencyRadioButton={props.onFrequencyRadioButton}
      typeOfFrequency={props.typeOfFrequency}
      showRadioFrequency={props.showRadioFrequency}
      showHistogramFields={props.showHistogramFields}
      onRecalculateGraph={props.onRecalculateGraph}
    />
    }
  </div>
);

SettingsFormComponent.propTypes = {
  firstDropdownParameters: PropTypes.object.isRequired,
  secondDropdownParameters: PropTypes.object.isRequired,

  firstDropdownValue: PropTypes.string.isRequired,
  secondDropdownValue: PropTypes.string.isRequired,
  firstParameterSelected: PropTypes.bool.isRequired,

  onFirstDropdownChange: PropTypes.func.isRequired,
  onSecondDropdownChange: PropTypes.func.isRequired,

  datasetLength: PropTypes.number.isRequired,

  numericalName: PropTypes.string.isRequired,
  showHistogramFields: PropTypes.bool,

  showSecondDropDown: PropTypes.bool.isRequired,
  showRadioFrequency: PropTypes.bool.isRequired,

  onRecalculateGraph: PropTypes.func.isRequired,
  onFrequencyRadioButton: PropTypes.func.isRequired,
  typeOfFrequency: PropTypes.string.isRequired,

  isEachDropdownDisabled: PropTypes.bool.isRequired,
  isScatterPlotTab: PropTypes.bool.isRequired
};

SettingsFormComponent.defaultProps = {
  showHistogramFields: false
};

export default SettingsFormComponent;
